import { ColorProps } from 'modules/shares/Inspector/Sidebar/components/Color/ColorDot'
import rgbTo from 'modules/shares/Inspector/Sidebar/components/Color/utils'
import { ColorFormat } from 'modules/shares/types'

export interface CopyProps {
  artboardWidth: number
  artboardHeight: number
  color?: ColorProps
  colorFormat?: ColorFormat
}

const copy = ({
  artboardWidth,
  artboardHeight,
  color,
  colorFormat,
}: CopyProps) => {
  const colorCopy = color ? `\nColor: ${rgbTo(colorFormat, color)}` : ``

  return `Width: ${artboardWidth}\nHeight: ${artboardHeight}` + colorCopy
}

export default copy
